<template>
	<el-input
		class="my-input"
		v-model="_value"
		:style="_style"
		v-bind="$attrs"
		:disabled="disabled"
		:placeholder="placeholder"
		@blur="blur"
		v-on="$listeners"
		:max="max"
		:min="min"
		:type="type"
	>
		<slot name="append" slot="append"></slot>
		<slot name="prefix" slot="prefix"></slot>
		<slot name="suffix" slot="suffix"></slot>
		<slot name="prepend" slot="prepend"></slot>
	</el-input>
</template>

<script>
export default {
	name: "input-item",
	props: {
		max: Number,
		min: Number,
		value: {
			type: String | Number
		},

		width: {
			type: String,
			default: "280px"
		},
		height: {
			type: String,
			default: "40px"
		},
		styleSheet: {
			type: Object,
			default: function() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
	},
	data() {
		return {};
	},
	computed: {
		_value: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		_style() {
			return Object.assign(
				{},
				{
					width: this.width,
					height: this.height,
					"line-height": this.height
				},
				this.styleSheet
			);
		}
	},
	methods: {
		change(val) {
			this._value = val;
		},
		blur() {
			this.$emit("blur");
		}
	}
};
</script>
<style lang='scss' scoped>
::v-deep.my-input.el-input {
	height: 32px;
	width: 280px;
	.el-input__inner {
		width: 100%;
		height: 100%;
		border: 1px solid rgba(0, 0, 0, 0.12);
		border-radius: 20px;
	}
}
::v-deep.my-input.el-input.el-input-group--append {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 20px;
	.el-input__inner {
		border: none;
		border-radius: none !important;
	}
	.el-input-group__append {
		border: none;
		border-top-right-radius: 20px;
		border-bottom-right-radius: 20px;
	}
}
</style>
